import { createAsyncThunk } from '@reduxjs/toolkit'
import { resetPassword } from '@services'

export const requestResetPassword = createAsyncThunk<
  void,
  { email: string; password: string; verificationCode: string }
>('resetPassword', async ({ email, password, verificationCode }) => {
  await resetPassword(email, password, verificationCode)
})
